(function () {
    'use strict';

    angular.module('Directives')
        .directive('bbaQuoteGoodsCheckSettings', bbaQuoteGoodsCheckSettings);

    function bbaQuoteGoodsCheckSettings() {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/bba-profile-manager/bba-quote-goods-check-settings.html',
            scope: {
                step: '=',
                init: '='
            },
            controller: bbaQuoteGoodsCheckSettingsController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    bbaQuoteGoodsCheckSettingsController.$inject = ['$scope'];

    function bbaQuoteGoodsCheckSettingsController($scope) {
        var vm = this;

        vm.signatureRequiredChecked = signatureRequiredChecked;
        vm.authorityToLeaveChecked = authorityToLeaveChecked;

        activate();

        function activate() {
            $scope.$watch(
                function () {
                    return vm.step && vm.step.details && vm.step.details.goodsCheck;
                },
                function (goodsCheck) {
                    if (!goodsCheck) {
                        return;
                    }

                    setAtlValues(goodsCheck);
                },
                true
            );
        }

        function setAtlValues(goodsCheck) {

            if (goodsCheck.unattendedDelivery === null || angular.isUndefined(goodsCheck.unattendedDelivery)) {
                setSignatureRequiredValue(goodsCheck, false);
                setAuthorityToLeaveValue(goodsCheck, false);
                return;
            }

            if (goodsCheck.unattendedDelivery) {
                setSignatureRequiredValue(goodsCheck, false);
                setAuthorityToLeaveValue(goodsCheck, true);
                return;
            }

            setSignatureRequiredValue(goodsCheck, true);
            setAuthorityToLeaveValue(goodsCheck, false);
        }

        function setSignatureRequiredValue(goodsCheck, value) {
            if (angular.isUndefined(goodsCheck.signatureRequired)) {
                goodsCheck.signatureRequired = value;
            }
        }

        function setAuthorityToLeaveValue(goodsCheck, value) {
            if (angular.isUndefined(goodsCheck.authorityToLeave)) {
                goodsCheck.authorityToLeave = value;
            }
        }

        function signatureRequiredChecked() {
            vm.step.details.goodsCheck.signatureRequired = true;
            vm.step.details.goodsCheck.authorityToLeave = false;
        }

        function authorityToLeaveChecked() {
            vm.step.details.goodsCheck.signatureRequired = false;
            vm.step.details.goodsCheck.authorityToLeave = true;
        }
    }

})();


// WEBPACK FOOTER //
// ./js/directives/component/bba-profile-manager/bbaQuoteGoodsCheckSettings.js